import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import HelpIcon from '../../../assets/help-circle.svg';
import {CREATE_FLOWS} from '../../../constants';
import {
  DARK_TEXT_COLOR,
  GREEN_BUTTON,
  GREY_90,
  GREY_BORDER_DEFAULT,
  WHITE_100,
} from '../../../theme';
import {isUploadFlow} from './CreateDocumentModal.utils';

const localStyles = {
  label: {
    color: DARK_TEXT_COLOR,
    fontSize: '0.875rem',
    fontWeight: '500',
    letterSpacing: '-0.14px',
    lineHeight: '130%',
  },
  switch: {
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          backgroundColor: GREEN_BUTTON,
          opacity: 1,
        },
        color: GREEN_BUTTON,
        transform: 'translateX(12px)',
      },
      padding: '2px',
    },
    '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
      backgroundColor: WHITE_100,
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: GREY_90,
      height: 16,
      width: 16,
    },
    '& .MuiSwitch-track': {
      backgroundColor: GREY_BORDER_DEFAULT,
      borderRadius: 100,
      opacity: 1,
    },
    height: 20,
    padding: 0,
    width: 32,
  },
};

export const WorkbookGenerationSelector = ({
  createFlow,
  orgConfig,
  setWorkbookGeneration,
  workbookGeneration,
}) => {
  if (createFlow !== CREATE_FLOWS.pdf && createFlow !== CREATE_FLOWS.upload) {
    return null;
  }

  return (
    <Stack direction="column" pt={2} spacing="0.5rem">
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        width="100%"
      >
        <Stack alignItems="center" direction="row" spacing="0.5rem">
          <Typography sx={localStyles.label}>
            Create a new Inscope workbook *
          </Typography>
          <Tooltip
            enterDelay={300}
            placement="top"
            title={
              <Typography fontSize={12} sx={{p: '5px'}}>
                <b>Recommended:</b>{' '}
                {isUploadFlow(createFlow)
                  ? "Link your Inscope document to your existing workbook. Only select create new Inscope workbook if you don't already have an existing one."
                  : "Roll forward and link your prior year workbook. Only create a new workbook if you don't already have an existing one."}
              </Typography>
            }
          >
            <img
              alt="Info"
              src={HelpIcon}
              style={{cursor: 'pointer', height: 16, width: 16}}
            />
          </Tooltip>
        </Stack>
        <Switch
          checked={workbookGeneration === 'yes'}
          onChange={(e) =>
            setWorkbookGeneration(e.target.checked ? 'yes' : 'no')
          }
          sx={localStyles.switch}
        />
      </Stack>
    </Stack>
  );
};

WorkbookGenerationSelector.propTypes = {
  createFlow: PropTypes.string,
  orgConfig: PropTypes.object,
  setWorkbookGeneration: PropTypes.func.isRequired,
  workbookGeneration: PropTypes.string.isRequired,
};
